function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#D80027;}\r\n\t.st1{fill:#FFDA44;}\r\n");

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st0",
  cx: 207,
  cy: 397,
  r: 256
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st1",
  points: "91.1,296.8 113.2,364.8 184.7,364.8 126.9,406.9 149,474.9 91.1,432.9 33.2,474.9 55.4,406.9  -2.5,364.8 69,364.8  "
}), React.createElement("polygon", {
  className: "st1",
  points: "254.5,537.5 237.6,516.7 212.6,526.4 227.1,503.9 210.2,483 236.1,489.9 250.7,467.4 252.1,494.2  278.1,501.1 253,510.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "288.1,476.5 296.1,450.9 274.2,435.4 301,435 308.9,409.4 317.6,434.8 344.4,434.5 322.9,450.5  331.5,475.9 309.6,460.4  "
}), React.createElement("polygon", {
  className: "st1",
  points: "333.4,328.9 321.6,353 340.8,371.7 314.3,367.9 302.5,391.9 297.9,365.5 271.3,361.7 295.1,349.2  290.5,322.7 309.7,341.4  "
}), React.createElement("polygon", {
  className: "st1",
  points: "255.2,255.9 253.2,282.6 278.1,292.7 252,299.1 250.1,325.9 236,303.1 209.9,309.5 227.2,289  213,266.3 237.9,276.4  "
}));

var SvgCny = function SvgCny(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-49 141 512 512",
    style: {
      enableBackground: "new -49 141 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCny, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CNY.7f8455b7.svg";
export { ForwardRef as ReactComponent };